import { render, staticRenderFns } from "./ExtrusionReceiptView.vue?vue&type=template&id=06588e88&scoped=true"
import script from "./ExtrusionReceiptView.vue?vue&type=script&lang=js"
export * from "./ExtrusionReceiptView.vue?vue&type=script&lang=js"
import style0 from "./ExtrusionReceiptView.vue?vue&type=style&index=0&id=06588e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06588e88",
  null
  
)

export default component.exports